import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RegistryFund } from '../../api/registryDealTypes';
import { errorMessage } from '../../api/registryApi';
import { useRegistrySession } from '../../session/RegistrySession';
import { PageHeader, SectionCard, StatusChip } from '../../ui/primitives';

export default function LiveFundsPage() {
  const session = useRegistrySession()!;
  const navigate = useNavigate();
  const [funds, setFunds] = useState<RegistryFund[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    session.api
      .listFunds()
      .then(setFunds)
      .catch((failure) => setError(errorMessage(failure)));
  }, [session]);
  return (
    <>
      <PageHeader
        title="Funds"
        subtitle="Registry funds and unit classes created from Fides deal setups."
        actions={
          <Button variant="contained" onClick={() => navigate('/manager/setup')}>
            Set up a deal
          </Button>
        }
      />
      <Alert severity="success" sx={{ mb: 2 }}>
        Live from Fides
      </Alert>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <SectionCard title="Registry funds">
        <Stack spacing={1}>
          {funds.length === 0 && <Typography>No registry funds yet.</Typography>}
          {funds.map((fund) => (
            <Paper key={fund.externalId} variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ flex: 1, fontWeight: 700 }}>
                  {fund.legalName} · {fund.code}
                </Typography>
                <StatusChip status={fund.status} />
                <Button onClick={() => navigate(`/manager/funds/${fund.externalId}`)}>
                  Classes and prices
                </Button>
              </Stack>
            </Paper>
          ))}
        </Stack>
      </SectionCard>
    </>
  );
}
